'use client'
import { createComponents } from '@theme/shared/light/create-components.jsx';
import { createPalette } from './create-palette';
import { createShadows } from './create-shadows';

export const createOptions = ({ colorPreset, contrast, branding }) => {
  const palette = createPalette({ colorPreset, contrast, branding });
  const components = createComponents({ palette });
  const shadows = createShadows();

  return {
    components,
    palette,
    shadows,
  };
};
